<script setup lang="ts">
import { MicrophoneIcon } from '@heroicons/vue/24/outline'
import { useSpeechRecognition } from '@/utils/useSpeechRecognition'

const props = withDefaults(defineProps<{
  lang?: string
  disabled?: boolean
}>(), {
  lang: 'fr-FR',
  disabled: false,
})

const emit = defineEmits<{
  result: [transcript: string]
}>()

const { isListening, isSupported, start, stop } = useSpeechRecognition(props.lang)

function onPress() {
  if (props.disabled) return
  start((transcript) => emit('result', transcript))
}

function onRelease() {
  stop()
}
</script>

<template>
  <button
    v-if="isSupported"
    type="button"
    :disabled="disabled"
    :title="isListening ? 'Relâchez pour valider' : 'Maintenez pour dicter'"
    class="btn btn-ghost btn-xs px-1 text-base-content/40 transition-colors select-none"
    :class="{ 'text-error animate-pulse': isListening }"
    @mousedown.prevent="onPress"
    @mouseup.prevent="onRelease"
    @mouseleave="onRelease"
    @touchstart.prevent="onPress"
    @touchend.prevent="onRelease"
  >
    <MicrophoneIcon class="w-4 h-4" />
  </button>
</template>
